import React, { useState, useEffect } from 'react';
import {
  Box, Heading, SimpleGrid, Card, CardBody, Text, Spinner, useToast, VStack, Tag, HStack, Image, Container, Divider, Icon, Tooltip
} from '@chakra-ui/react';
import { FaUser, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import axios from 'axios';

const API_BASE_URL = 'https://api-amg2dwk5ga-uc.a.run.app';

const BusinessList = () => {
  const [businesses, setBusinesses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    const fetchBusinesses = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${API_BASE_URL}/api/businesses`);
        setBusinesses(response.data);
      } catch (error) {
        toast({ title: 'Error fetching businesses', status: 'error' });
      } finally {
        setIsLoading(false);
      }
    };
    fetchBusinesses();
  }, [toast]);

  if (isLoading) return <VStack justify="center" align="center" h="50vh"><Spinner size="xl" /></VStack>;

  return (
    <Container maxW="container.xl" py={12}>
      <Heading mb={8} textAlign="center">Our Community Businesses</Heading>
      {businesses.length === 0 ? (
        <Text textAlign="center" fontSize="lg" color="gray.500">
            No featured businesses found.
        </Text>
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
          {businesses.map((business) => (
            <Card key={business.id} borderWidth="1px" borderRadius="lg" overflow="hidden" boxShadow="md">
              {business.is_premium ? (
                // If premium, show the real business image
                <Image
                  src={`https://firebasestorage.googleapis.com/v0/b/bagdaconnect.firebasestorage.app/o/${encodeURIComponent(business.photo_business_url)}?alt=media`}
                  alt={`${business.business_name} photo`}
                  objectFit="cover"
                  h="200px"
                />
              ) : (
                // If not premium, show a placeholder wrapped in a Tooltip
                <Tooltip label="Enable premium mode to show your business photos" fontSize="md" hasArrow placement="top">
                  <Image
                    src='https://via.placeholder.com/400x200?text=Premium+Feature'
                    alt='Upgrade to premium to show image'
                    objectFit="cover"
                    h="200px"
                    filter='grayscale(90%)' // Style to look like a disabled feature
                    opacity='0.7'
                    cursor="pointer"
                  />
                </Tooltip>
              )}
              <CardBody>
               <VStack align="stretch" spacing={4}>
                  <HStack justify="space-between">
                    <Heading size="md">{business.business_name}</Heading>
                    {business.offers_discount && <Tag colorScheme="green" size="lg">Discount Available</Tag>}
                  </HStack>

                  {/* --- CHANGE 3: Redesigned details section with icons --- */}
                  <Divider />
                  <VStack spacing={3} align="stretch" color="gray.600">
                    <HStack>
                      <Icon as={FaUser} color="brand.700" />
                      <Text fontWeight="medium">{business.owner_name}</Text>
                    </HStack>
                    <HStack>
                      <Icon as={FaPhone} color="brand.700" />
                      <Text fontSize="sm">{business.phone_number}</Text>
                    </HStack>
                    <HStack>
                      <Icon as={FaMapMarkerAlt} color="brand.700" />
                      <Text fontSize="sm">{business.address}</Text>
                    </HStack>
                  </VStack>
                </VStack>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      )}
    </Container>
  );
};

export default BusinessList;